/**
 * @license BCP
 * (c) 2015 Openprovider. http://openprovider.eu
 * @author Eugene Semennikov esemennikov@openprovider.ru
 * License: MIT
 */
(function() {'use strict';

/**
 * @ngdoc module
 * @name intro
 * @description
 *
 * # intro
 *
 * The `intro` module provides main page.
 */
angular.module("intro", [])
/**
 * @ngdoc controller
 * @name introCtrl
 * @requires $scope
 *
 * @description
 * Intro Controller
 */
  .controller("introCtrl", function ($scope, exportToCsv) {

    $scope.exportAllProductRecordsToCsv = exportToCsv.downloadAllProductRecordsToFile;

  });

})();
